import ModalTemplate from "./template";
import Button from "../../../components/shared/button";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../../redux/reducers/root";
import { hideModal } from "../../../redux/actions/modals";

interface Props {}

const CommentInfo: React.FC<Props> = () => {
  const doctor = useSelector((state: State) => state.selectDoctor);
  const dispatch = useDispatch();

  const hide = () => {
    dispatch(hideModal());
  };

  const share = () => {
    const { id, slug, name } = doctor;
    const url = `https://pezeshkekhoob.com/doctor/${id}-${slug}`;

    if (navigator.share)
      navigator.share({
        title: name,
        text: name,
        url,
      });
    else if (navigator.clipboard) {
      navigator.clipboard.writeText(url);
    } else window.open(url, "_blank");
    hide();
  };

  return (
    <ModalTemplate title="جزئیات و روند نمایش نظرات" icon="far fa-star">
      <div className="p-5 text-gray-500 text-normal">
        <ul className="list-disc">
          <li>بررسی و تائید نظرات حداقل دو روز کاری زمان می‌برد. حالت نمایش نظرات بالای هر نظر مشخص است.</li>
          <li>نظرات کاربرانی که بیش از یک نظر برای یک متخصص خاص درج کرده اند فقط یک بار تائید می‌شود. </li>
          <li>هم چنین نظرات آشنایان درجه یک تائید نمی‌شود.</li>
          <li>
            به دلیل اهمیت نقش نظرات و امتیازات در جذب مراجعه کنندگان برای شما، لطفا از مراجعان خود بخواهید از طریق آدرس
            صفحه شما در سایت، نسبت به ثبت نظر و امتیاز اقدام کنند.
          </li>
        </ul>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Button className="w-full" type="submit" variant="outline" onClick={share}>
          ارسال آدرس صفحه
        </Button>

        <Button className="w-full" onClick={hide}>
          بستن توضیحات
        </Button>
      </div>
    </ModalTemplate>
  );
};
export default CommentInfo;
